export const API_URLS = {
  // COURTS: 'http://localhost:8080/courts',
  // SEARCH: 'http://localhost:8080/search'
  COURTS: `${process.env.REACT_APP_API_URL}/api/courts`,
  JURISDICTIONS: `${process.env.REACT_APP_API_URL}/api/jurisdictions`,
  SEARCH: `${process.env.REACT_APP_API_URL}/api/search`,
  SUGGESTIONS: `${process.env.REACT_APP_API_URL}/api/suggestions`,
  SEARCH_JUDGES: `${process.env.REACT_APP_API_URL}/api/courthouse-personnel/judges/suggestions`,
  SEARCH_PROSECUTORS: `${process.env.REACT_APP_API_URL}/api/courthouse-personnel/prosecutors/suggestions`,
  SEARCH_ATTORNEYS: `${process.env.REACT_APP_API_URL}/api/courthouse-personnel/attorneys/suggestions`,
  SEARCH_DEFENDANTS: `${process.env.REACT_APP_API_URL}/api/courthouse-personnel/defendants/suggestions`,
  SEARCH_CHARGES: `${process.env.REACT_APP_API_URL}/api/courthouse-personnel/charges/suggestions`,
  ALL_CHARGES: `${process.env.REACT_APP_API_URL}/api/courthouse-personnel/charges/all`,
  DEPARTMENTS: `${process.env.REACT_APP_API_URL}/api/departments`,
  JUDGES_FOR_DEPARTMENT: `${process.env.REACT_APP_API_URL}/api/judges/department`,
  JUDGES_FOR_COURTHOUSE_DEPARTMENT: `${process.env.REACT_APP_API_URL}/api/courthouse-personnel/judges/courthouse-department`,
  ANALYTICS_JUDGE: `${process.env.REACT_APP_API_URL}/api/analytics/judge`,
  ANALYTICS_PROCECUTOR: `${process.env.REACT_APP_API_URL}/api/analytics/prosecutor`,
  SCRAPING: `${process.env.REACT_APP_API_URL}/api/scraping`,
  // Reports endpoints
  REPORTS_YEARS: `${process.env.REACT_APP_API_URL}/api/reports/years`,
  REPORTS_SUMMARY: `${process.env.REACT_APP_API_URL}/api/reports/summary`,
  REPORTS_CHARGES: `${process.env.REACT_APP_API_URL}/api/reports/charges`,
  REPORTS_TOP_CHARGES: `${process.env.REACT_APP_API_URL}/api/reports/top-charges`,
  REPORTS_CHARGE_STATS: `${process.env.REACT_APP_API_URL}/api/reports/charge`,
  REPORTS_COURTHOUSE_STATS: `${process.env.REACT_APP_API_URL}/api/reports/courthouse`,
  REPORTS_JUDGE_STATS: `${process.env.REACT_APP_API_URL}/api/reports/judge`,
  REPORTS_PROCECUTOR_STATS: `${process.env.REACT_APP_API_URL}/api/reports/prosecutor`,
  // Stripe/Subscription endpoints
  CREATE_SUBSCRIPTION: `${process.env.REACT_APP_API_URL}/api/create-subscription`,
  CREATE_TRIAL_SUBSCRIPTION: `${process.env.REACT_APP_API_URL}/api/create-trial-subscription`,
  CANCEL_SUBSCRIPTION: `${process.env.REACT_APP_API_URL}/api/cancel-subscription`,
  REFRESH_SUBSCRIPTION: `${process.env.REACT_APP_API_URL}/api/refresh-subscription`,
  RESUBSCRIBE: `${process.env.REACT_APP_API_URL}/api/resubscribe`,
  UPDATE_PAYMENT_METHOD: `${process.env.REACT_APP_API_URL}/api/update-payment-method`,
  GET_PAYMENT_METHOD: (subscriptionId) =>
    `${process.env.REACT_APP_API_URL}/api/subscription/${subscriptionId}/payment-method`,
  // Case edit endpoints
  CASE_EDITS: (caseNumber) =>
    `${process.env.REACT_APP_API_URL}/api/cases/${caseNumber}/edits`,
  CASE_EDIT_HISTORY: (caseNumber) =>
    `${process.env.REACT_APP_API_URL}/api/cases/${caseNumber}/edits/history`
};
